var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",class:['title-' + _vm.tag, _vm.mod, 'xs'],domProps:{"innerHTML":_vm._s(_vm.content)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }